
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class DimensionSelect extends Vue {
  @Prop({ type: Boolean, default: false }) large!: boolean;
  @Prop({ type: Boolean, default: false }) huge!: boolean;
  @Prop({ type: String, default: "" }) text!: string;
  @Prop({ type: Number, default: 14 }) fontSize!: string;
  @Prop({ type: String, default: "" }) color!: string;
  @Prop({ type: Boolean, default: false }) useDefaultSlot!: boolean;
  @Prop({ type: Boolean, default: true }) useDefaultTemp!: boolean;

  get className() {
    if (this.huge) return "newBluePop huge";

    if (this.large) return "newBluePop large";

    return "newBluePop";
  }

  mounted() {
    //pop组件要求class名不能使用数组或函数
  }
}
